/**
 * Adaptation des projets copiés de « Création d'un projet — v3 » au modèle de cartes
 * local (`./home.types`) : créateur et partage deviennent des personnes,
 * les copies sont regroupées avec leur projet d'origine.
 */
import type { Collaborator, ProjectCardItem, ProjectFamily } from './home.types';
import type { ProjectSummary } from './types';

/** Utilisateur connecté de la démonstration — sépare « mes projets » de ceux de l'entité. */
export const CURRENT_USER = 'Camille Martin';

export function person(name: string): Collaborator {
  const initials = name
    .split(/[\s-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
  return { id: name.toLowerCase().replace(/\s+/g, '-'), name, initials };
}

export function toCardItem(p: ProjectSummary): ProjectCardItem {
  return {
    id: p.id,
    name: p.name,
    kind: p.kind === 'new' ? 'new' : 'extension',
    perimeterLabel: p.perimeterLabel,
    networkNames: p.networkNames,
    buildingCount: p.buildingCount,
    planCount: p.planCount,
    parentId: p.parentId,
    copyCount: p.copyCount,
    snapshotDate: p.snapshotDate,
    owner: person(p.owner),
    members: p.members.map(person),
    archived: p.archived,
    updatedAt: p.updatedAt,
    contract: p.contract,
    favorite: p.favorite,
  };
}

/** Regroupe une liste de projets en familles : projet d'origine puis ses copies. */
export function toFamilies(list: ProjectCardItem[]): ProjectFamily[] {
  const byId = new Map(list.map((p) => [p.id, p]));
  return list
    .filter((p) => !p.parentId || !byId.has(p.parentId))
    .map((root) => ({ root, copies: list.filter((p) => p.parentId === root.id) }));
}
